import { css } from "styled-components";
import VTEBackground from 'assets/images/VTEBackground.jpg';

export const HelveticaneueRegularNormalBlack13px = css`
  color: var(--black);
  font-family: var(--font-family-Poppins);
  font-size: var(--font-size-xl2);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsMediumWhite7px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-s);
  font-weight: 500;
  font-style: normal;
`;

export const PoppinsNormalGunsmoke10px = css`
  color: var(--gunsmoke);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalBlackRock16px = css`
  color: var(--black-rock);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxxl);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalConcrete7px = css`
  color: var(--concrete);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalWhite7px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsMediumBlueViolet22px = css`
  color: var(--blue-violet);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxxxl);
  font-weight: 500;
  font-style: normal;
`;

export const PoppinsNormalConcrete14px = css`
  color: var(--concrete);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxl2);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalWhite18px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: 18px;
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalConcrete14px2 = css`
  color: var(--concrete);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxl2);
`;

export const PoppinsBoldConcrete14px = css`
  color: var(--concrete);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxl2);
  font-weight: 700;
  font-style: normal;
`;

export const PoppinsNormalBlueViolet15px = css`
  color: var(--blue-violet);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxl);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalGunsmoke9px = css`
  color: var(--gunsmoke);
  font-family: var(--font-family-poppins);
  font-size: 9px;
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalWhite12px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsMediumWhite22px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxxxl);
  font-weight: 500;
  font-style: normal;
`;

export const PoppinsNormalBlueViolet14px = css`
  color: var(--blue-violet);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxl2);
`;

export const PoppinsNormalBlackcurrant14px = css`
  color: var(--blackcurrant);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxl2);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalBlueViolet14px2 = css`
  color: var(--blue-violet);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxl2);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalBlueViolet17px = css`
  color: var(--blue-violet);
  font-family: var(--font-family-poppins);
  font-size: 17px;
  font-weight: 400;
  font-style: normal;
`;

export const Border1pxBlueViolet = css`
  border: 1px solid var(--blue-violet);
`;

export const PoppinsNormalChicago12px = css`
  color: var(--chicago);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
  font-weight: 400;
  font-style: normal;
`;
export const PoppinsNormalBlueViolet12px = css`
  color: var(--blue-violet);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsMediumBlackRock22px = css`
  color: var(--black-rock-2);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxxxl);
  font-weight: 500;
  font-style: normal;
`;

export const PoppinsMediumBlack12px = css`
  color: var(--black);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
  font-weight: 500;
  font-style: normal;
`;

export const PoppinsMediumWhite12px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
  font-weight: 500;
  font-style: normal;
`;

export const PoppinsMediumWhite20px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
  font-weight: 500;
  font-style: normal;
`;

export const Border1pxEbb = css`
  border: 1px solid var(--ebb);
`;

export const BorderRadius4px = css`
  border-radius: 4px;
`;

export const InputAndButton = css`
  ${Border1pxEbb}
  ${BorderRadius4px}
  height: 42px;
  display: flex;
  background-color: var(--white);
`;

export const PoppinsNormalEbony12px = css`
  color: var(--ebony);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
`;

export const PoppinsBoldEbony12px = css`
  color: var(--ebony);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
  font-weight: 700;
  font-style: normal;
`;

export const PoppinsNormalEbony12px2 = css`
  color: var(--ebony);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsBoldBlueViolet14px = css`
  color: var(--blue-violet);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxl2);
  font-weight: 700;
  font-style: normal;
`;

export const PoppinsBoldBlueViolet11px = css`
  color: var(--blue-violet);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-s);
  font-weight: 700;
  font-style: normal;
`;

export const Border1pxPixiePowder = css`
  border: 1px solid var(--pixie-powder);
`;

export const Gradient1 = css`  
  background-image: url(${VTEBackground});
  background-size: cover;                
  background-position: center;           
  background-repeat:repeat;
`;

export const Gradient2 = css`
  background: rgb(99, 82, 232);
  background: transparent linear-gradient(180deg, var(--color-6352e8) 0%, #3712b3 100%) 0% 0% no-repeat padding-box;
  background: linear-gradient(180deg, #6352e8 0%, #3712b3 100%);
  
`;

export const Gradient3 = css`
  background:#160133;
`;

export enum Colors {
  black = "black",
  blackHaze = "black-haze",
  blackRock = "black-rock",
  blueViolet = "blue-violet",
  chicago = "chicago",
  ebb = "ebb",
  white = "white",
}
